import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './DisputeDetail.css';

const DisputeDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [dispute, setDispute] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      const mockDispute = {
        id: id,
        title: 'Service Quality Dispute',
        vessel: 'MV Ocean Star',
        amount: 12500,
        raisedBy: 'Ocean Star Management',
        against: 'Dubai Ship Repair',
        status: 'open',
        priority: 'high',
        raisedDate: 'Mar 15, 2024',
        description: 'Service not completed as per specifications. GMDSS equipment not properly calibrated.',
        resolution: null
      };
      setDispute(mockDispute);

      const mockMessages = [
        { id: 1, sender: 'Ocean Star Management', message: 'The repair work was not done properly. Equipment still showing errors.', timestamp: 'Mar 15, 2024 10:30 AM', isAdmin: false },
        { id: 2, sender: 'Dubai Ship Repair', message: 'All work completed as per agreement. Please check again.', timestamp: 'Mar 15, 2024 11:00 AM', isAdmin: false },
        { id: 3, sender: 'Admin', message: 'We are reviewing this dispute. Please provide evidence.', timestamp: 'Mar 15, 2024 02:00 PM', isAdmin: true }
      ];
      setMessages(mockMessages);
      setLoading(false);
    }, 500);
  }, [id]);

  const handleSendMessage = () => {
    if (newMessage.trim()) {
      const newMsg = {
        id: messages.length + 1,
        sender: 'Admin',
        message: newMessage,
        timestamp: new Date().toLocaleString(),
        isAdmin: true
      };
      setMessages([...messages, newMsg]);
      setNewMessage('');
    }
  };

  const handleResolve = () => {
    alert('Dispute resolved successfully!');
    navigate('/admin/disputes');
  };

  if (loading) return <div className="loading-spinner">Loading...</div>;

  return (
    <div className="dispute-detail-page">
      <button className="back-btn" onClick={() => navigate(-1)}>
        <i className="fas fa-arrow-left"></i> Back to Disputes
      </button>

      <div className="dispute-container">
        <div className="dispute-header">
          <h1>Dispute #{dispute.id}</h1>
          <div className="dispute-meta">
            <span className={`status-badge ${dispute.status}`}>{dispute.status}</span>
            <span className="priority-badge">{dispute.priority}</span>
          </div>
        </div>

        <div className="dispute-info-grid">
          <div className="info-item">
            <span className="info-label">Vessel</span>
            <span className="info-value">{dispute.vessel}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Amount</span>
            <span className="info-value">${dispute.amount.toLocaleString()}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Raised By</span>
            <span className="info-value">{dispute.raisedBy}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Against</span>
            <span className="info-value">{dispute.against}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Raised Date</span>
            <span className="info-value">{dispute.raisedDate}</span>
          </div>
        </div>

        <div className="dispute-description">
          <h3>Description</h3>
          <p>{dispute.description}</p>
        </div>

        <div className="messages-section">
          <h3>Conversation</h3>
          <div className="messages-list">
            {messages.map(msg => (
              <div key={msg.id} className={`message-item ${msg.isAdmin ? 'admin' : 'user'}`}>
                <div className="message-sender">{msg.sender}</div>
                <div className="message-text">{msg.message}</div>
                <div className="message-time">{msg.timestamp}</div>
              </div>
            ))}
          </div>
          <div className="message-input">
            <textarea
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              placeholder="Type your message..."
              rows="3"
            />
            <button onClick={handleSendMessage} className="send-btn">
              <i className="fas fa-paper-plane"></i> Send
            </button>
          </div>
        </div>

        <div className="action-buttons">
          <button className="resolve-btn" onClick={handleResolve}>
            <i className="fas fa-check-circle"></i> Resolve Dispute
          </button>
          <button className="escalate-btn">
            <i className="fas fa-arrow-up"></i> Escalate
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisputeDetail;